<template>
  <div v-loading="isLoading">
    <el-table
      :data="attachments"
      stripe
    >
      <el-table-column
        label="File Name"
        prop="file"
        min-width="320px"
        show-overflow-tooltip
        :formatter="(row, col, cellValue) => cellValue ? (cellValue.name || '-') : '-'"
      />

      <el-table-column
        label="File Type"
        prop="file"
        width="120px"
        :formatter="(row, col, cellValue) => cellValue ? (cellValue.type || '-') : '-'"
      />

      <el-table-column
        label="Uploaded By"
        width="240px"
        :formatter="(row, col, cellValue) => $_.get(row, 'file.creator.name')"
      />

      <el-table-column
        label="Attached At"
        prop="created_at"
        width="180px"
        :formatter="(row, col, cellValue) => cellValue ? $moment(cellValue).format('DD/MM/YYYY hh:mm a') : '-'"
      />

      <!-- <el-table-column
        label="Status"
        width="180px"
      >
        <template slot-scope="scope">
          <el-tag
            v-if="scope.row.file.is_shared"
            type="default"
            size="small"
          >
            Shared
          </el-tag>

          <el-tag
            v-if="scope.row.file.is_public"
            class="ml-2"
            type="warning"
            size="small"
          >
            Public
          </el-tag>
        </template>
      </el-table-column> -->

      <el-table-column
        label="Actions"
        align="right"
        width="270px"
      >
        <template slot-scope="scope">
          <el-button-group class="pr-2">
            <el-button
              size="mini"
              @click.native="$file.download(scope.row.file.id)"
            >
              Download
            </el-button>

            <!-- <el-button
              v-if="canUpdate"
              size="mini"
              @click.native="editAttachment(scope.row)"
            >
              Share
            </el-button> -->
          </el-button-group>

          <el-button-group>
            <el-button
              v-if="canDelete"
              size="mini"
              type="danger"
              @click.native="deleteAttachment(scope.$index, scope.row)"
            >
              Delete
            </el-button>
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>

    <!-- Pagination -->
    <el-pagination
      class="text-center pt-3"
      :current-page.sync="page"
      :page-sizes="[10, 20, 50, 100]"
      :page-size.sync="perPage"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      @size-change="loadTable"
      @current-change="loadTable"
    />

    <!-- Attach Form -->
    <AttachmentAttachForm
      ref="attachForm"
      :account-id="accountId"
      @saved="loadTable"
    />

    <!-- Upload Form -->
    <AttachmentUploadForm
      ref="uploadForm"
      :account-id="accountId"
      @saved="loadTable"
    />

    <!-- Edit Form -->
    <AttachmentEditForm
      v-if="isShowEditForm"
      ref="editForm"
      :attachment="attachment"
      :is-show.sync="isShowEditForm"
      @reload="loadTable"
    />
  </div>
</template>

<script>
import AttachmentAttachForm from '@/components/Application/Manage/Account/AttachmentAttachForm'
import AttachmentUploadForm from '@/components/Application/Manage/Account/AttachmentUploadForm'
import AttachmentEditForm from '@/components/Application/Manage/Account/AttachmentEditForm'
import { CREATE, UPDATE, DELETE } from '@/plugins/user'
export default {
  components: {
    AttachmentAttachForm,
    AttachmentUploadForm,
    AttachmentEditForm
  },
  props: {
    accountId: {
      type: String,
      required: true
    },
    filters: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      attachment: null,
      attachments: [],
      page: 1,
      perPage: 10,
      total: 0,
      isLoading: true,
      isShowEditForm: false
    }
  },
  computed: {
    canUpdate () {
      return this.$user.can(UPDATE, 'account_attachment')
    },
    canDelete () {
      return this.$user.can(DELETE, 'account_attachment')
    }
  },
  mounted () {
    this.actions = [
      {
        hidden: this.$user.cannot(CREATE, 'account_attachment'),
        name: 'Upload & Attach',
        icon: ['fal', 'upload'],
        event: () => {
          this.$refs.uploadForm.isShow = true
        }
      },
      {
        name: 'Refresh',
        icon: ['fal', 'sync'],
        event: () => this.loadTable()
      }
    ]
  },
  methods: {
    loadTable () {
      this.isLoading = true
      this.$sdk.attachment.list(builder => {
        builder.context = { resource: 'account', id: this.accountId }
        builder.page = this.page
        builder.limit = this.perPage
        builder.order = 'created_at:desc'
        builder.filters = this.filters
      })
        .then(res => {
          this.attachments = res
          this.total = res.total
        })
        .finally(() => { this.isLoading = false })
    },
    deleteAttachment (index, row) {
      this.$confirm('Are you sure to delete this attachment?', 'Delete', {
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        this.isLoading = true
        row.delete()
          .then(() => this.$message({ message: 'Successfully deleted', type: 'success' }))
          .finally(() => this.loadTable())
      }).catch(() => {})
    },
    editAttachment (row) {
      this.attachment = row.clone()
      this.isShowEditForm = true
    }
  }
}
</script>

<style>

</style>
